import { useContext, useEffect } from 'react';

import { setModeFactory } from '../../actions/sign-up/SignUpActions';
import { SignUpModes } from '../../constants';
import SignUpContext from '../../contexts/sign-up/SignUpContext';

const useMode = (mode: SignUpModes) => {
    const { dispatch } = useContext(SignUpContext);
    const setMode = setModeFactory(dispatch);

    useEffect(() => {
        setMode(mode);
    }, [mode]);
};

export default useMode;
